export enum CollapseIconPosition {
  Left = 'left',
  Right = 'right'
}
